<template>
<div class="main-view-page">
    <PageLoader />
    <Header />
    <main id="main-content">
      <div class="container">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </main>
    <Footer />
</div>
</template>

<script>
import { AuthenticationService } from "@/services/auth-services";
import { useAuthUser } from "@/stores/auth-store";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import PageLoader from "@/components/PageLoader.vue";
import { useNavStore } from "@/stores/navigation-store";
import { useCartStore } from "@/stores/cart-store";
import { useFavStore } from "@/stores/favorites-store";

const authService = new AuthenticationService();

export default {
    name: 'PrivateView',
    components: {
        Header,
        Footer,
        PageLoader
    },
    methods: {
        async getUser() {
            try {
                this.authUser.user = await authService.getUser(this.authUser.getToken);
            } catch(error) {
                return false
            }
        },
    },
    async beforeMount() {
        this.navStore.pageLoading = true
        this.authUser.$subscribe(async (callback, state) => {
            this.user = state.user
        })
        this.getUser().then(() => {
            this.navStore.pageLoading = false
        }).catch(() => {})
        this.cartStore.initCart()
        this.favStore.initFavList()
    },
    setup() {
        const authUser = useAuthUser()
        const navStore = useNavStore()
        const cartStore = useCartStore()
        const favStore = useFavStore()
        return {
            authUser,
            navStore,
            cartStore,
            favStore,
        };
    },
}
</script>